var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncubatorBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#506EF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17H8.5C7.5 17 7 16.5 7 15.5V11.5C7 10.5 7.5 10 8.5 10M12.5 17C11.5 17 11 16.5 11 15.5M12.5 17H15.5C16.5 17 17 16.5 17 15.5V8.5C17 7.5 16.5 7 15.5 7H12.5C11.5 7 11 7.5 11 8.5M8.5 10H11M8.5 10V9C8.5 8.45 8.95 8 9.5 8H11.055C11.015 8.15 11 8.315 11 8.5M11 10V15.5M11 10V8.5M11 15.5V8.5M13 10V12.5M15 10V12.5M9 12.5V14.5M14.5 14.5H13.5C13.225 14.5 13 14.725 13 15V17H15V15C15 14.725 14.775 14.5 14.5 14.5Z",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncubatorBadge);
export default __webpack_public_path__ + "static/media/IncubatorBadge.178f8d50bc259969424b3c616e31b4e2.svg";
export { ForwardRef as ReactComponent };